export enum ContentPagesList {
  HOME = 'home',
  ACTOR = 'actor',
  PROJECT = 'project',
  RESOURCE = 'resource',
  SERVICE = 'service',
}
